import dayjs from "dayjs";

import TranslatedText from "@components/items/display/TranslatedText";
import { ReaderPlanItem } from "@modules/local/db";
import { SubscriptionCard as SubscriptionCardImg } from "@components/images/SubscriptionCard/SubscriptionCard";

interface SubscriptionCardProps {
  plan: ReaderPlanItem | null;
}

export const SubscriptionCard = ({ plan }: SubscriptionCardProps) => {
  return (
    <div className="relative mx-auto mt-4 h-[277px] w-[448px]">
      <SubscriptionCardImg  />
      <div className="absolute left-0 top-0 h-full w-full">
        <div className="mx-auto mt-[118px] w-fit text-center text-[32px] font-medium text-white">
          {plan?.planName}
        </div>
        {!plan?.isFree && (
          <>
            <div className="mt-4 text-center text-[16px] font-medium text-white/70">
              {plan?.name}
            </div>
            <div className="absolute bottom-6 right-5 text-[16px] font-medium text-white/60">
              <TranslatedText text="subscription.titles.active to" />
              <div>
                {plan?.expiration
                  ? dayjs(plan.expiration).format("YYYY/MM/DD")
                  : "_"}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
